











































































































import VueOptions from '@utils/VueOptions'
import Calendar from '@ui/Calendar/MiniCalendar'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'
import VenueFilter from '@ui/Venue/VenueFilter'

settings =
  name: 'VenueResourceList'

  vue:
    props: ['venues', 'infiniteWrapper', 'actions', 'options']
    components: {
      Calendar,
      ResourceList,
      LoadingIndicator,
      VenueFilter,
    }

    data: ->
      isAllSelected: false
      selectedVenues: []
      nextPage: 1
      target:
        scopes: ['has_published_availabilities']
        q: ''

      mapOptions:
        draggable: true
        zoomControl: false
        mapTypeControl: false
        scaleControl: false
        streetViewControl: false
        rotateControl: false
        fullscreenControl: false
        disableDefaultUi: true

    computed:
      components: ->
        'venue-card': () => import('@ui/cards/VenueCard')

      resourceKey: ->
        @options?.resourceKey || 'venues'

      listItemActions: -> {}

      zoom: -> 14
      lat: -> 40.78201595778718
      lng: -> -73.97176021091232

    mounted: ->
      @nextPage = 1
      @hiInfiniteScroll()

    methods:
      hiApplyFilters: ->
        @$refs.infiniteLoading.stateChanger.reset()
        @nextPage = 1
        @actions.fetchResource null, @resourceKey, @target, { page: @nextPage }
        @nextPage += 1

      hiSearchChange: ->

      hiSelectAll: (checked) ->
        @selectedVenues = []
        @selectedVenues.push(...@venues) if checked

      hiDeselectAll: ->
        @isAllSelected = false
        @selectedVenues = []

      hiInfiniteScroll: (state) ->
        @actions.fetchResource state, @resourceKey, @target, { page: @nextPage }
        @nextPage += 1

      hiNavToVenueEditor: ->
        venues = 'all' if @isAllSelected
        venues ||= @selectedVenues.map((item) -> item.id)
        @actions?.bulkEdit venues

      hiNavToVenueCreate: ->
        @$router.push { name: 'VenueCreatePage' }

    watch:
      venues: (value) ->
        @selectedVenues.push(...@venues) if @isAllSelected

export default VueOptions.vue settings
